import { ColumnLayout, styled } from '@a0/quantum-product';
export var ColumnStack = styled(ColumnLayout)({
    gridTemplateColumns: 'none',
    gridAutoColumns: 'min-content',
    gridAutoFlow: 'column',
    alignItems: 'center',
});
